<template>
    <div>
        <form-group label="Date of Drive" name="date" :required="true">
            <datepicker v-model="expense.date" :max-date="maxDate"/>
        </form-group>

        <div class="flex flex-wrap">
            <div class="w-full md:w-1/2">
                <form-group label="Distance (km)" name="distance" :required="true">
                    <div class="flex">
                        <input type="number"
                               min="0"
                               step="1"
                               placeholder="0"
                               class="input text-right amount-int-input"
                               v-model="expense.distance[0]"
                               pattern="[0-9]{*}">
                        <div class="input-group-addon">,</div>
                        <input type="number" min="0" step="1" class="input w-16" v-model="expense.distance[1]"
                               pattern="([0-9]|[0-9])">
                    </div>
                </form-group>
            </div>
        </div>

        <form-group label="Reason for Drive" name="reason" :required="true">
            <div class="flex">
                <input type="text"
                       class="input"
                       v-model="expense.reason">
            </div>
        </form-group>

        <form-group label="Route" name="route" :required="true">
            <div class="flex">
                <input type="text"
                       class="input"
                       v-model="expense.route">
            </div>
        </form-group>

        <form-group label="Attachments" name="attachments" :required="false">
            <file-upload :url="fileUploadUrl"
                         :deleteUrl="fileDeleteUrl"
                         v-model="expense.attachments"
                         @activeFileUpload="$emit('activeFileUpload', $event)">
            </file-upload>
        </form-group>

    </div>
</template>

<script>

import Form from './form';
import InteractsWithDates from '@/mixins/InteractsWithDates';
import FileUpload from '@/components/DragUpload.vue';

export default {
    mixins: [Form, InteractsWithDates],

    components: {
        FileUpload
    },

    props: ['value', 'fileUploadUrl', 'fileDeleteUrl'],

    data() {
        return {
            expense: {
                ...{
                    distance: [0, 0],
                    route: '',
                    reason: ''
                }, ...this.value,
            },
        }
    },

}
</script>
